import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  connect() {
    // Listen for lines added event from add line modal
    this.boundLinesAddedHandler = this.handleLinesAdded.bind(this)
    document.addEventListener('add-line-modal:lines-added', this.boundLinesAddedHandler)
  }

  disconnect() {
    document.removeEventListener('add-line-modal:lines-added', this.boundLinesAddedHandler)
  }

  handleLinesAdded(event) {
    const { addedLines, duplicatesCount } = event.detail

    // Reload the media plan to show new lines
    this.reloadMediaPlan()
  }

  reloadMediaPlan() {
    // Check if we're on Angular page and reload through Angular
    if (window.angular && window.angular.element) {
      // Try to find MediaPlanCtrl scope
      const mediaplanElement = document.querySelector('[ng-controller="MediaPlanCtrl"]') ||
                              document.querySelector('[data-controller="media-plan"]') ||
                              document.body

      const scope = window.angular.element(mediaplanElement).scope()
      if (scope && scope.$apply) {
        scope.$apply(() => {
          // Call the specific media plan reload method
          if (typeof scope.getBudgetLinesStats === 'function') {
            scope.getBudgetLinesStats()
          } else if (scope.reloadMediaPlan) {
            scope.reloadMediaPlan()
          } else if (scope.reload) {
            scope.reload()
          } else {
            window.location.reload()
          }
        })
        return
      }
    }

    // Fallback: reload the page if no Angular scope found
    window.location.reload()
  }
}
